import { createContext } from 'react';
import type { LinkPreview } from '../utils/linkThumbnail';

/** Per-MarkdownContent instance; cleared when the provider unmounts. */
export type MarkdownLinkPreviewCache = ReadonlyMap<string, LinkPreview | null>;

export const MarkdownLinkPreviewContext =
  createContext<MarkdownLinkPreviewCache>(new Map());
